import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout(event) {
    let target = event?.target;
    if (!(target instanceof HTMLInputElement)) {
      target = target?.closest?.('label')?.querySelector('input');
    }
    if (!(target instanceof HTMLInputElement)) return;

    this.#setLayout(target.value);

    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
    try {
      sessionStorage.setItem(`product-grid-view-${viewport}`, target.value);
    } catch (_) {}
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const grid = this.refs?.grid || this.querySelector('.product-grid') || document.querySelector('.product-grid');
    if (grid) {
      grid.setAttribute('product-grid-view', value);
    }

    const radios = document.querySelectorAll('input[type="radio"][name="grid"], input[type="radio"][name="grid-mobile"]');
    radios.forEach((radio) => {
      radio.checked = radio.value === value;
    });
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (targetElement instanceof HTMLInputElement) {
      targetElement.checked = true;
    }
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
